<template>
  <a-modal
    centered
    :maskClosable="false"
    title="选择房号"
    v-model="visible"
    width="800px"
    :confirmLoading="confirmLoading"
    @ok="onSubmit"
    @cancel="onCancel"
  >
    <div style="text-align:right;">
      <a-input-search
        placeholder="房号/订单号/客人姓名"
        v-model="Keyword"
        style="width:300px"
        enter-button
        @search="onSearch"
      />
    </div>
    <div class="item-content">
      <a-radio-group
        v-model="checkedValue"
        class="checkgroup-box"
        v-if="orderList.length"
      >
        <template v-for="item in orderList">
          <p class="g-title" :key="item.OrderId">
            订单号：<span @click="checkOrder(item.OrderId)">{{
              item.OrderNo
            }}</span>
          </p>
          <a-radio
            :style="radioStyle"
            v-for="room in item.AppointRoomInfos"
            :value="room.RoomInfoId"
            :key="room.GuestId"
            class="check-item"
          >
            <span class="room-no">
              {{ room.RoomNo ? room.RoomNo : "未排房" }}</span
            >
            <span class="guest-room"> 客人姓名：{{ room.GuestName }}</span>
            <span class="date">
              住离日期：{{ room.CheckInDate }} 至 {{ room.CheckOutDate }}</span
            >
          </a-radio>
        </template>
      </a-radio-group>
      <div class="no-room" v-else>无数据！</div>
    </div>
  </a-modal>
</template>
<script>
import {
  OrderDetailModal,
  TeamOrderDetailModal
} from "@/views/orderManage/funtion.js";
export default {
  props: {
    defaultItem: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      visible: false,
      checkedValue: "",
      orderList: [],
      Keyword: "",
      radioStyle: {
        display: "block",
        height: "30px",
        lineHeight: "30px"
      },
      confirmLoading: false,
      info: {},
      allRoomData: []
    };
  },
  created() {},
  methods: {
    show(record) {
      this.visible = true;
      this.allRoomData = [];
      this.info = record;
      this.checkedValue = "";
      this.Keyword = "";
      this.getRoomNos();
    },
    onSearch(value) {
      this.Keyword = value;
      this.getRoomNos();
    },
    getRoomNos() {
      this.orderList = [];
      this.$post("Breakfast_GetRoomNos", {
        Keyword: this.Keyword,
        OrderStatus: 1
      }).then(res => {
        if (res.Data.length) {
          this.orderList = res.Data.map(v => {
            if (v.AppointRoomInfos && v.AppointRoomInfos.length) {
              v.AppointRoomInfos = v.AppointRoomInfos.map(el => {
                el.TargetOrderId = v.OrderId;
                return el;
              });
              this.allRoomData = this.allRoomData.concat(v.AppointRoomInfos);
            }
            return v;
          });
        }
      });
    },
    onSubmit() {
      if (!this.checkedValue) {
        this.$message.error("请选择转客房的房号!");
        return false;
      }
      const result = this.allRoomData.find(
        el => el.RoomInfoId == this.checkedValue
      );
      this.$emit("submit", this.checkedValue, result, this.info);
      this.visible = false;
    },
    onCancel() {
      this.checkedValue = "";
      this.visible = false;
      this.$emit("cancel", this.info);
    },
    checkOrder(Id) {
      if (this.defaultItem.PlusHotelOrderModel == 1) {
        TeamOrderDetailModal({
          orderId: Id,
          showBtn: false
        });
      } else {
        OrderDetailModal({
          orderId: Id,
          showBtn: false
        });
      }
    }
  }
};
</script>
<style lang="less">
.item-content {
  margin: 10px 0;
  border: 1px solid #eee;
  border-radius: 3px;
  height: calc(100vh - 400px);
  overflow: hidden;
  overflow-y: auto;
  padding: 10px;
}
.checkgroup-box {
  width: 100%;
  .g-title {
    background: #f5f5f5;
    padding: 5px 15px;
    color: #333;
    margin-top: 12px;
    margin-bottom: 5px;
    span {
      font-size: 16px;
      color: #0084fe;
      text-decoration: underline;
      cursor: pointer;
    }
    &:first-child {
      margin-top: 0;
    }
  }
  .ant-checkbox-wrapper {
    display: block;
    height: 30px;
    line-height: 30px;
    margin-left: 15px;
  }
  .ant-checkbox-wrapper + .ant-checkbox-wrapper {
    margin-left: 15px;
  }
  .check-item {
    .room-no {
      display: inline-block;
      width: 110px;
    }
    .guest-room {
      display: inline-block;
    }
    .date {
      float: right;
    }
  }
}
.no-room {
  text-align: center;
  font-size: 18px;
  background: #fafafa;
  padding: 50px;
  margin-top: 10px;
}
</style>
